import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { TIMELINE_PATHNAME } from 'timeline/enums/constants';

interface IGridScrollEvent {
  alwaysCompressHeader?: boolean;
  compare: Array<string>;
  defaultScrollPosition?: number;
}

/**
 * [useGridScrollEvent]
 * listens for scroll events, and
 * depending on the current scroll position
 * returns whether aspects of the Search Grid
 * should be sticky, super compress or not
 */

export const useGridScrollEvent = ({
  alwaysCompressHeader = false,
  compare = [],
}: IGridScrollEvent) => {
  const { pathname } = useRouter();
  const isGoatCleanPath = pathname === '/goat-clean';
  const isSearchPath = pathname === '/search';
  const isTimelinePath = pathname === TIMELINE_PATHNAME;
  const isWantsPath = pathname === '/wants';
  const [superCompressHeader, setSuperCompressHeader] = useState(
    isSearchPath || isTimelinePath || isGoatCleanPath || isWantsPath || alwaysCompressHeader,
  );

  useEffect(() => {
    if (!isSearchPath && !isGoatCleanPath && !isTimelinePath && !alwaysCompressHeader) {
      setSuperCompressHeader(false);
    }
  }, compare);

  return {
    superCompressHeader,
    setSuperCompressHeader,
    alwaysCompressHeader:
      isSearchPath || isTimelinePath || isGoatCleanPath || isWantsPath || alwaysCompressHeader,
  };
};
